// extracted by mini-css-extract-plugin
export default {"googleContainer":"Google_googleContainer__fb2Ng","googleLoginButton":"Google_googleLoginButton__B2zvf"};